<div class="phone-assistance-banner" #sectionElement>
  <app-container>
    <div class="phone-assistance-banner__container" (click)="onBannerClick()">
      <div class="phone-assistance-banner__content">
        <!-- Left side - Image -->
        <div class="phone-assistance-banner__image-container">
          <img
            src="https://www.unipay.cl/api/descargaArchivo/web-perro-duda.png"
            alt="Servicio al cliente"
            class="phone-assistance-banner__image"
          />
        </div>
        <div class="phone-assistance-banner__icon-container-small">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="phone-assistance-banner__icon"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
        </div>
        <!-- Middle - Title -->
        <div class="phone-assistance-banner__title-container">
          <h3 class="phone-assistance-banner__title">
            ¿Necesitas ayuda?
          </h3>
        </div>

        <!-- Separator -->
        <div class="phone-assistance-banner__separator"></div>

        <!-- Right side - Phone info -->
        <div class="phone-assistance-banner__phone-info">
          <div class="phone-assistance-banner__icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="phone-assistance-banner__icon"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
          </div>
          <div>
            <p class="phone-assistance-banner__text">
              Llámanos al
              <span class="phone-assistance-banner__phone-number">600 390 9000</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </app-container>
</div>
